import * as React from 'react';

import { cn } from '../../lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, value, onChange, ...props }, ref) => {
    const handleChange = React.useCallback(
      (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (onChange) {
          onChange(e);
        }
      },
      [onChange]
    );

    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-[#095D52] bg-[#0B222C] px-3 py-2 text-sm text-[#ede8c5] placeholder:text-[#8aa39d] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#bbe425] disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        value={value}
        onChange={handleChange}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };
